import React, { Component } from "react";
import Fade from "react-reveal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTelegram, faVk, faOdnoklassniki,  } from "@fortawesome/free-brands-svg-icons";
import maxLink from "./photos/Max.svg";
class Footer extends Component {
  render() {
    if (!this.props.data) return null;

    return (
      <footer style={{ backgroundColor: "#0f0f0f" }}>
        <div className="row">
          <Fade bottom>
            <div className="twelve columns">
              <ul className="social-links">
                <li>
                  <a href="https://vk.com/tsnigri">
                    <FontAwesomeIcon icon={faVk} />
                  </a>
                  <a href="https://t.me/tsnigri">
                    <FontAwesomeIcon icon={faTelegram} />
                  </a>
                  <a href="https://ok.ru/group/70000003099553 ">
                    <FontAwesomeIcon icon={faOdnoklassniki} />
                  </a>
                  <a href="https://max.ru/id7726429427_gos">                  
                    <img class ="social-icon-img" src="images/elements/Max.svg" width="25px;"></img>
                  </a>
                  <a href="https://rutube.ru/channel/31116730/">                  
                    <img class ="social-icon-img" src="images/elements/rutube.svg" width="25px;"></img>
                  </a>
                </li>
              </ul>

              <ul className="copyright">
                <li>ФГБУ&nbsp;«ЦНИГРИ»&nbsp;{new Date().getFullYear()} </li>
                <li>
                  Разработка сайта -{" "}
                  {/*<a title="Tsnigri" href="http://www.tsnigri.ru/ru/about/structura/n-issledovatelskie-podrazdeleniya/nauchno-informatsionnoe-otdelenie/otgeoinfors.html"> Отдел ГИС ФГБУ «ЦНИГРИ </a>*/}
                  <a title="Tsnigri" href="http://www.tsnigri.ru/ru"> ФГБУ «ЦНИГРИ </a>
                  &nbsp;и&nbsp;
                  <a
                    title="Github"
                    href="https://github.com/nordicgiant2/react-nice-resume"
                  >
                    Github Community
                  </a>
                </li>
              </ul>
            </div>
          </Fade>

          <div id="go-top">
            <a className="smoothscroll" title="К началу" href="#home">
              <i className="icon-up-open"></i>
            </a>
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
